import * as React from 'react';
import {
    Datagrid,
    Edit,
    NumberInput,
    BooleanInput,
    ReferenceManyField,
    TextInput,
    TabbedForm,
    FormTab,
    SaveButton,
    Toolbar,
    FileInput,
    FileField,
    DateTimeInput,
    ReferenceField,
    DateField,
    FunctionField,
    Labeled,
} from 'react-admin';
import {
    required,
    minValue,
    maxValue,
    minLength,
    maxLength,
    number,
    email,
    regex,
    choices,
} from 'react-admin';
import { Grid, Box } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';

import {
    CustomSelectInput,
    CustomSelectArrayInput,
    CustomCheckboxGroupInput,
    CustomRadioButtonGroupInput,
    CustomJSONPretty,
    CustomTextField,
    CustomBulkDeleteButton,
    CustomBulkAddButton,
    CustomProductList,
    CustomNumberInput,
    CustomLogEventList,
} from '../controls';

import { 
    LibraryBooks,
    Article,
    Podcasts,
    Attachment,
    DataObject,
    TransferWithinAStation,
    History,
} from '@mui/icons-material';

import {
    DefaultEditorOptions,
    RichTextInput,
    RichTextInputToolbar,
    LevelSelect,
    FormatButtons,
    AlignmentButtons,
    ListButtons,
    LinkButtons,
    QuoteButtons,
    ClearButtons,
    useTiptapEditor,  
} from 'ra-input-rich-text';
 //import { RichTextInput } from 'ra-input-rich-text';

const EditToolbar = () => {
    return (
        <Toolbar>
            <SaveButton />
        </Toolbar>
    );
};

const AnnouncementEdit = () => {

    return (
        <Edit redirect={false} mutationMode="optimistic">
            <TabbedForm toolbar={<EditToolbar />} >
                <FormTab label="resources.announcement.tabs.details" icon={<Article />}>
                    
                        <Grid container width={{ xs: '100%' }} spacing={2}>
                            <Grid size={12}>
                                <TextInput resource="announcement" source="name" validate={[required()]} fullWidth />
                                <TextInput resource="announcement" source="public.message" multiline validate={[required()]} fullWidth />
                                {/* <RichTextInput resource="announcement" source="public.message" validate={[required()]} /> */}
                                <TextInput resource="announcement" source="public.read_more" fullWidth />
                            </Grid>

                            <Grid size={{ xs: 2, md: 2 }}>
                                <Box display={{ xs: 'block', sm: 'flex' }}>
                                    <Box flex={1} mr={{ xs: '0.5em' }}><DateTimeInput resource="announcement" source="valid_from" /></Box>
                                    <Box flex={1} mr={{ xs: '0.5em' }}><DateTimeInput resource="announcement" source="valid_until" /></Box>
                                </Box>
                            </Grid>

                            <Grid size={12}>
                                <Box display={{ xs: 'block', sm: 'flex' }}>
                                    <Box flex={1} mr={{ xs: '0.5em' }}><CustomRadioButtonGroupInput resource="announcement" source="status" url="extralist/announcement/statuses" parse={v => parseInt(v)} /></Box>
                                    <Box flex={1} mr={{ xs: '0.5em' }}><CustomCheckboxGroupInput resource="announcement" source="public.languages" url="extralist/announcement/languages" /></Box>
                                    <Box flex={1} mr={{ xs: '0.5em' }}><CustomCheckboxGroupInput resource="announcement" source="public.applications" url="extralist/announcement/applications" /></Box>
                                    <Box flex={1} mr={{ xs: '0.5em' }}><CustomCheckboxGroupInput resource="announcement" source="public.imprint" url="extralist/announcement/imprints" /></Box>
                                </Box>
                            </Grid>
                            
                            <Grid size={12}>
                                <TextInput resource="announcement" source="public.tags" fullWidth />
                            </Grid>

                            <Grid size={{ xs: 12, md: 6 }}>
                                <Box display={{ xs: 'block', sm: 'flex' }}>
                                    <Box flex={1} mr={{ xs: '0.5em' }}>
                                        <Tooltip placement="top-start" title={`Häiriötiedotteet on tarkoitettu tilanteisiin, joissa palvelu ei toimi lainkaan tai sen käyttö on merkittävästi häiriintynyt. Pienemmät bugit ja palvelun käytön kannalta vähemmän kriittiset ongelmat tulee ilmoittaa Tiedote-kategorian kautta. Huomioithan, että järjestelmä näyttää vain yhden häiriötiedotteen kerrallaan. Uusi häiriötiedote ei tule näkyviin, jos aiemmin julkaistu on vielä voimassa.`}><CustomSelectInput resource="announcement" source="public.announcement_type" url="extralist/announcement/types" fullWidth /></Tooltip>
                                        <CustomSelectArrayInput resource="announcement" source="public.categories" url="extralist/product/categories" fullWidth />
                                    </Box>
                                </Box>
                            </Grid>

                            <Grid size={{ xs: 12, md: 6 }}>
                                <Box display={{ xs: 'block', sm: 'flex' }}>
                                    <Box flex={1} mr={{ xs: '0.5em' }}>
                                        <CustomSelectArrayInput resource="announcement" source="public.types" url="extralist/school/types" fullWidth />
                                        <CustomSelectArrayInput resource="announcement" source="public.typegroups" url="extralist/school/type_groups" fullWidth />
                                    </Box>
                                </Box>
                            </Grid>

                            <Grid size={12}>
                                <Box display={{ xs: 'block', sm: 'flex' }} sx={{marginBottom: '10px'}}>
                                    <Labeled>
                                        <>
                                        <ReferenceField reference="user" source="author.creator">
                                            <FunctionField render={record => `${record.public.firstname} ${record.public.lastname}, `} />
                                        </ReferenceField>
                                        <DateField resource="announcement" source="author.created" showTime locales="fi-FI" />
                                        </>
                                    </Labeled>
                                </Box>
                                <Box display={{ xs: 'block', sm: 'flex' }} sx={{marginBottom: '10px'}}>
                                    <Labeled>
                                        <>
                                        <ReferenceField reference="user" source="author.modifier">
                                            <FunctionField render={record => `${record.public.firstname} ${record.public.lastname}, `} />
                                        </ReferenceField>
                                        <DateField resource="announcement" source="author.modified" showTime  locales="fi-FI" />
                                        </>
                                    </Labeled>
                                </Box>
                            </Grid>

                        </Grid>
                    
                </FormTab>
            </TabbedForm>
        </Edit>
    );
};

const redirect: any = () => {
    return window.location.hash.replace('#', '');
}

export default AnnouncementEdit;